<template>
  <div class="project-member">
    <header class="top-wrap">
      <div class="main-title">项目成员</div>
      <div class="right">
        <!--<el-input-->
        <!--  v-model="searchText"-->
        <!--  class="mRight10"-->
        <!--  size="small"-->
        <!--  placeholder="搜索姓名"-->
        <!--  clearable-->
        <!--  @keyup.native.enter="search"-->
        <!--  @clear="search"-->
        <!--&gt;-->
        <!--  <el-button slot="append" icon="el-icon-search" @click="search"></el-button>-->
        <!--</el-input>-->
        <el-button type="primary" size="small" @click="openDialog('create')">添加成员</el-button>
      </div>
    </header>
    <main class="main-wrap">
      <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
      <BaseTable
        v-else
        ref="BaseTable"
        tableHeight="100%"
        :tableColumns="tableColumns"
        :tableData="filterData"
        :pageInfo="pageInfo"
        :show-pagination="false"
      >
        <template v-slot:table-suffix>
          <el-table-column prop="handle" label="操作" width="160">
            <template v-slot="scope">
              <el-button @click.stop="openDialog('edit', scope.row)" type="text" size="mini">
                编辑
              </el-button>
              <el-button @click.stop="toRemove(scope.row)" type="text" size="mini">
                移出项目
              </el-button>
            </template>
          </el-table-column>
        </template>
      </BaseTable>
    </main>
    <add-member-dialog
      :visible.sync="dialogVisible"
      :from="dialogType"
      :project-id="projectId"
      :user="currentUser"
      @submit="addOrEditUser"
    ></add-member-dialog>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseComponents/Table"
import AddMemberDialog from "./AddMemberDialog"
import { memberTableColumns as tableColumns } from "./static"
import * as ProjectApi from "@/api/project/project"

export default {
  name: "project-member",
  components: { BaseTable, AddMemberDialog },
  data() {
    return {
      tableColumns,
      showTable: false,
      memberList: [],
      roleList: [],
      filterData: [],
      pageInfo: {
        total: 1000,
        currentPage: 1,
        pageSize: 20
      },
      searchText: "",
      projectId: this.$route.params.projectId,
      dialogVisible: false,
      dialogType: "create",
      currentUser: null
    }
  },
  created() {
    this.refreshList()
  },
  methods: {
    refreshList() {
      ProjectApi.getProjectMembers(this.projectId).then(membersList => {
        membersList = membersList.map(role => {
          role.roleStr = role.projectRoles.map(r => r.name).join(",")
          return role
        })
        this.memberList = membersList
        this.showTable = true
        this.filterData = membersList
      })
      ProjectApi.getAllProjectRole(this.projectId).then(roleList => {
        this.roleList = this._.keyBy(roleList, "id")
      })
    },
    search() {
      //
    },
    openDialog(from, user) {
      this.dialogType = from
      this.currentUser = user ?? null
      this.dialogVisible = true
    },
    toRemove(member) {
      ProjectApi.deleteProjectMembers([{ userId: member.userId }], this.projectId).then(() => {
        this.$message.success("操作成功")
        this.refreshList()
      })
    },
    addOrEditUser(members) {
      members[0].roles.map(m => {
        // 新增该角色人员时查询角色中是否已有主负责人且不是系统角色，如果没有就将当前人员设置为该角色的主负责人
        if (
          this.roleList[m]?.mainAssignee === undefined &&
          this.roleList[m]?.description !== "系统角色"
        ) {
          let form = {
            id: this.roleList[m].id,
            name: this.roleList[m].name,
            description: this.roleList[m].description,
            mainAssignee: members[0].userId
          }
          ProjectApi.saveProjectRole(form, this.projectId)
        }
      })
      if (this.dialogType === "create") {
        ProjectApi.addProjectMembers(members, this.projectId).then(() => {
          this.$message.success("操作成功")
          this.refreshList()
        })
      } else if (this.dialogType === "edit") {
        let form = members[0]
        ProjectApi.updateMemberRoles(form?.roles, form?.userId, this.projectId).then(() => {
          this.$message.success("操作成功")
          this.refreshList()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.project-role {
  .right ::v-deep {
    .el-input-group__append {
      padding: 0 10px;
    }
  }
}
</style>
